@use "~theme/typography";

.div {
  @include typography.heading4;
  align-items: center;
  background-color: var(--blue-03);
  border-bottom: 1px solid var(--blue-01-at-30);
  border-top: 1px solid var(--blue-01-at-30);
  color: var(--blue-01);
  display: flex;
  justify-content: center;
  padding: 8px;
  width: 100%;
}

.divV2 {
  @include typography.heading4;
  align-items: center;
  background-color: var(--blue-03);
  border-radius: 2px;
  height: 34px;
  color: var(--blue-01);
  display: flex;
  justify-content: center;
  padding: 8px;
  margin-left: 12px;
  margin-right: 12px;
  width: 95%;
  span {
    width: 90%;
  }
}